import { useQuery } from '@hooks/reactQuery';

import { getHistoryCheckTechnologies } from '@api/hitoryCheck';

import { extractQueryParams } from '@utils/common';
import { optionsFormattedWithAvailability } from '@utils/formatter';

import { TCMTechnologiesOptions } from '@interfaces/cmModule/cmModule';
import { IVendor } from '@interfaces/cmModule/dto/cmModuleDTO';
import { TSelectOption } from '@interfaces/components/componentTypes';

import { EVendorsValues } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { HISTORY_CHECK_TECHNOLOGY } from '@constants/queryKeys';

type TUseQueryHistoryCheckTechnologies = IVendor

interface IUseQueryHistoryCheckTechnologiesReturnValue {
	technologiesOptions?: TSelectOption[];
	isLoading: boolean;
}

export const useQueryHistoryCheckTechnologies = ({
	vendor,
}: TUseQueryHistoryCheckTechnologies): IUseQueryHistoryCheckTechnologiesReturnValue => {
	const {
		data: technologiesOptions,
		isInitialLoading,
	} = useQuery<TCMTechnologiesOptions[], TSelectOption[]>({
		queryKey: [HISTORY_CHECK_TECHNOLOGY, vendor],
		queryFn: extractQueryParams(getHistoryCheckTechnologies),
		select: (options) => optionsFormattedWithAvailability(options),
		enabled: [!!vendor, vendor !== EVendorsValues.mavenir, vendor !== EVendorsValues.oran],
		...refetchOptions,
	});

	return {
		technologiesOptions,
		isLoading: isInitialLoading,
	};
};
